<div class="row align-items-center">
  <span></span>
  <div *ngIf="!isInvalid;else warnOnSubmit" class="text-success">
    <i class="fa fa-check-circle"></i>
  </div>
</div>
<ng-template #warnOnSubmit>
  <div *ngIf="submitted && (!noErrorOnFocus || !isFocused)">
    <span *ngIf="errorAsText;else errorIcon" class="text-danger">
      <small>Please fill all required details</small>
    </span>
    <ng-template #errorIcon>
      <span class="text-danger"> * </span>
    </ng-template>
  </div>
</ng-template>